import { render, staticRenderFns } from "./user-organization-table.vue?vue&type=template&id=51a72960&"
import script from "./user-organization-table.vue?vue&type=script&lang=ts&"
export * from "./user-organization-table.vue?vue&type=script&lang=ts&"
import style0 from "./user-organization-table.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports